<template>
    <transition name="confirm-fade">
      <div v-if="isShowConfirm" class="my-confirm">
        <div class="wrap" @click.stop>
          <div :class="['hello-block', { 'container-dark': theme_dark }]">
            <div class="arc">
              <div class="bg ub">
                <img class="tag-bg" src="../assets/img/谢谢参与.png" alt="">
                <img class="tag-love" src="../assets/img/new2024/love.png" alt="">
              </div>
              <div class="head-txt ub ub-pc ub-ac">
                <img class="tag-love" src="../assets/img/new2024/love.png" alt="">
                <h1>有缘人</h1>
                <img class="tag-blink" src="../assets/img/new2024/bg-all.png" alt="">
              </div>
            </div>

            <ul class="user-list ub ub-ac ub-pc flexWrap ub-ps">
              <li v-for="(i, index) in arr" :key="index"  @click="choseImg(i)">
                <div :style="{ 'background-image': 'url(' + baseurl + i.photo + ')' }" class="photo ub ub-ae">
                  <div class="state" v-if="i.on">
                    <img src="../assets/img/radio.png">
                  </div>
                </div>
                <div class="ub ub-ac ub-pc"><span class="nick">{{ i.nick.length > 5 ? i.nick.substr(0,4) + '...' : i.nick }}</span></div>
              </li>
            </ul>

            <div class="btn-block ub ub-ac ub-pc">
              <div class="btn ub ub-ac ub-pc" @click="say_hello()">
                <span>打招呼</span>
                <div class="love">
                  <img class="love-icon" src="../assets/img/new2024/love.png" alt="#"/>
                </div>
              </div>
            </div>
          </div>

          <div class="ub ub-pc ub-ac">
            <img class="close-img" src="../assets/img/new2024/close.png"/>
          </div>
          
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../api/common";
  export default {
    data() {
      return {
        isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
        theme_dark: false,
        baseurl: this.$store.state.url + "/photo/",
        arr: [],
        i_tag: 0,
        hello_info: {}
      };
    },
    mounted() {
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo"]),
  
      init_page() {
        
      },
  
      show() {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
        this.isShowConfirm = true;
        //打招呼弹框控制
        localStorage.setItem('loc_is_sayHello', "已弹框");

        var uid = this.$store.state.uid;
        var self = this;
        self.get({
          url:"/App/Get_User_NewUser?uid=" + uid,
          success: function(data) {
            for (var i in data) {
              var item_user = data[i];
              item_user.on = true;
            }
            self.arr = data;
          },
          error: function(res) {}
        });

        self.get({
          url:"/App/GetCnfig_SayHelloMsg",
          success: function(data) {
            self.init_helloInfo(data);
          },
          error: function(res) {}
        });

      },
      hidden() {
        this.isShowConfirm = false;
      },
      clickFun(type) {
        this.hidden();
      },
      choseImg(selectedItem) {
        var index = this.arr.findIndex(item => item === selectedItem);
        if (index !== -1) {
          this.arr[index].on = !this.arr[index].on;
        }
      },

      //发送打招呼
      say_hello() {
        var msg = {};
        var self = this;
        for(var i = 0; i < self.arr.length; i++ ) {
          setTimeout(()=>{
            var msg_txt = self.get_msg_txt();
            msg = {
              to: self.arr[self.i_tag++].uid,
              msg_type: msg_txt.msg_type,
              msg_txt: msg_txt.txt
            };
            self.send(msg);
          },100 * i)
        }
      },

      send: function (msg) {
        //发送消息
        var send_msg = { to: msg.to, type: msg.msg_type, txt: msg.msg_txt };
        this.$socket.emit("send_one", send_msg);
        //整理消息，本地store中保存
        send_msg.dtm = new Date().Format("yyyy/MM/dd hh:mm:ss");
        this.$store.commit("push_message", send_msg);
        this.$store.commit("set_msg_count");
        this.$toast.center("发送成功");
        this.hidden();
      },

      //初始化打招呼数据
      init_helloInfo(data) {
        var uid = this.$store.state.uid;
        var self = this;
        self.act_get_userinfo({
        uid: uid,
        success: function (u) {
            if (u.sex == "女生") {
              self.hello_info = data.girl;
            }
            if (u.sex == "男生") {
              self.hello_info = data.boy;
            }
          },
        });
      },

      get_msg_txt() {
        var msg_txt = {};
        var arr_hello = this.hello_info;
        if (arr_hello.length > 0) {
           msg_txt = arr_hello[Math.floor(Math.random() * arr_hello.length)];
        }

        if (!msg_txt || !msg_txt.msg_type || !msg_txt.txt) {
            msg_txt = {
                "msg_type": "text",
                "txt": "你好"
            };
        }
        return msg_txt;
      }

    },
  };
  </script>
  
  <style lang="scss" scoped>
  .my-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  
  /* 进入和出去的动画 */
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }
  /* 进来的动画 */
  @keyframes opacity {
    0% {
      opacity: 0;
    }
  
    100% {
      opacity: 1;
    }
  }
  
  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  /* 包裹层容器样式 */
  .wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 85%;
    margin: 0 auto;
    z-index: 999;
    border-radius: 2rem;
    user-select: none;
  }

  .hello-block {
    position: relative;
    padding: 5rem 0.8rem 0 0.8rem;
    border-radius: 2rem;
    background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
    .user-list {
      padding: 1rem 0.8rem;
      .photo {
        margin: 0.5rem;
        width: 4.5rem;
        height: 4.5rem;
        background-size:cover;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 0.5rem;
        .state {
          margin-top: 0.1rem;
          margin-right: 0.1rem;
          img {
            width: 1rem;
            height: 1rem;
          }
        }
      }
      .nick {
        font-size: 0.9rem;
        font-weight: bold;
        color: #333;
      }
    }

    

    .btn-block {
      padding-bottom: 2rem;
      
      .btn {
        flex: 1;
        margin: 0 4rem;
        padding: 0.8rem 0;
        background: linear-gradient(#8a61ff, #fe9cc0);
        border-radius: 2rem;
        position: relative;
        cursor: pointer;
        animation: heartbeat 1.5s ease infinite;
        span {
            font-size: 1.1rem;
            font-weight: bold;
            color: #FFFFFF;
        }
      }
      @keyframes heartbeat {
        0% {
          transform: scale(1);
        }
        30% {
          transform: scale(1.1);
        }
        50% {
          transform: scale(1);
        }
        70% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }
      .love {
        position: absolute;
        right: 0;
        width: 2.9rem;
        height: 2.9rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #fff;
        background: linear-gradient(#8a61ff, #fe9cc0);
        img {
          margin-top: 0.5rem;
          margin-left: 0.1rem;
          width: 2rem;
          height: 2rem;
        }
      }
    }
  }

  .arc {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5rem;
      // background: linear-gradient(#8a61ff, #fe9cc0);
      background-image: url(../assets/img/new2024/bg-chat.png);
      border-top-left-radius: 2rem;
      border-top-right-radius: 2rem;
      border-bottom-left-radius: 50%;
      border-bottom-right-radius: 50%;
      box-shadow: #f3eaed 0px 5px 0px 0px;
      .bg {
        position: absolute;
        left: 50%;
        right: 50%;
        margin-left: -2rem;
        margin-top: -2rem;
        .tag-bg {
          width: 4rem;
          height: 4rem;
        }
        .tag-love {
          width: 0.8rem;
          height: 0.8rem;
          margin-top: 1rem;
        }
      }
      
      .head-txt {
        height: 100%;
        h1 {
          margin: 0;
          font-weight: bold;
          color: #FFFFFF;
          z-index: 10;
        }
        .tag-blink {
          width: 0.8rem;
          height: 0.8rem;
          margin-left: 0.3rem;
        }
        .tag-love {
          width: 0.8rem;
          height: 0.8rem;
          margin-right: 0.5rem;
        }
      }
    }
  
  .close-img {
      width: 2rem;
      margin-bottom: -4rem;
  }
  
  .container-dark {
    background: linear-gradient(to bottom, #9c365c, #333 3rem);
    .arc {
      box-shadow: #2d2d2d 0px 5px 0px 0px;
    }
    .user-list {
        .nick {
          color: #fff;
        }
    }
  }
  </style>
  